import MetodoEntrega from './MetodoEntrega'

export default MetodoEntrega
